import React from 'react';
import { motion } from 'framer-motion';
import { useMouseMoveUI } from '../../contexts/mouse-move-context';
import {Link} from "react-router-dom";

const CourseBreadcrumb = ({ course }) => {
    const { id = "",
        category = "",
        subcategory = "",
        courseHasLabelList = [],
        image240x135 = "",
        title = "xxxx",
        headline = "xxxx",
        visibleInstructorList = []
    } = course || {};
    const { mouseDirection, mouseReverse } = useMouseMoveUI();


    const getInstructor = (
        visibleInstructorList?.map((instructor, index) =>
            <Link key={index} to={`/instructorInfo/${instructor.id}`}>
                {instructor.displayName + (!(visibleInstructorList.length === index + 1) ? ", " : "")}
            </Link>
        ))

    const getLabel = (
        courseHasLabelList?.filter(courseHasLabel => courseHasLabel.isPrimary).map((courseHasLabel, index) =>
            <><span> </span><Link key={index} to={`/courses/${category.id}/${subcategory.id}/${courseHasLabel.label.id}`}>{courseHasLabel.label.title}</Link></>
        )
    )

    return (
        <div className="edu-breadcrumb-area breadcrumb-style-3">
            <div className="container">
                <div className="breadcrumb-inner">
                    <ul className="edu-breadcrumb">
                        {/*<li className="breadcrumb-item">*/}
                        {/*    <Link to={`/courses/${category.id}`}>{category.title}</Link>*/}
                        {/*</li>*/}
                        {/*<li className="separator"><i className="icon-angle-right"></i></li>*/}
                        {/*<li className="breadcrumb-item">*/}
                        {/*    <Link to={`/courses/${category.id}/${subcategory.id}`}>{subcategory.title}</Link>*/}
                        {/*</li>*/}
                        {/*<li className="separator"><i className="icon-angle-right"></i></li>*/}
                        {/*<li className="breadcrumb-item">*/}
                        {/*    {getLabel}*/}
                        {/*</li>*/}
                        {/*/!*<li className="separator"><i className="icon-angle-right"></i></li>*!/*/}
                        {/*/!*<li className="breadcrumb-item active" aria-current="page">{subtitle}</li>*!/*/}
                    </ul>
                    <div className="page-title">
                    <h3 className="title">{title}</h3>
                    <p>{headline}</p>
                    </div>
                    <ul className="course-meta">
                    <li><i className="icon-58"></i>{getInstructor}</li>
                        {/*<li><i className="icon-59"></i>{language}</li>*/}
                        {/*<li className="course-rating">*/}
                        {/*<div className="rating">*/}
                        {/*    <i className="icon-23"></i>*/}
                        {/*    <i className="icon-23"></i>*/}
                        {/*    <i className="icon-23"></i>*/}
                        {/*    <i className="icon-23"></i>*/}
                        {/*    <i className="icon-23"></i>*/}
                        {/*</div>*/}
                        {/*<span className="rating-count">({rating_count} Rating)</span>*/}
                        {/*</li>*/}
                    </ul>
                </div>
            </div>
            <ul className="shape-group">
                <li className="shape-1">
                    <span></span>
                </li>
                <motion.li className="shape-2 scene"
                    animate={ {
                        x: mouseReverse(40).x,
                        y: mouseReverse(40).y
                    } }
                >
                    <img src="/assets/images/about/shape-13.png" alt="shape" />
                </motion.li>
                <motion.li className="shape-3 scene"
                    animate={ {
                        x: mouseDirection(40).x,
                        y: mouseDirection(40).y
                    } }
                >
                    <img src="/assets/images/about/shape-15.png" alt="shape" />
                </motion.li>
                <li className="shape-4">
                    <span></span>
                </li>
                <motion.li className="shape-5 scene"
                    animate={ {
                        x: mouseReverse(40).x,
                        y: mouseReverse(40).y
                    } }
                >
                    <img src="/assets/images/about/shape-07.png" alt="shape" />
                </motion.li>
            </ul>
        </div>
    )
}

export default CourseBreadcrumb;